import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {
  ClipboardList, AlertTriangle, FileSignature, HeartPulse, Ban, MessageCircleQuestion, ListChecks,
} from "lucide-react";
import { translateFr as tfr } from "@/i18n";

const Section = ({ Icon, title, tone, items, text, testid }) => {
  if ((!items || items.length === 0) && !text) return null;
  return (
    <div className="rounded-xl border border-border bg-secondary/30 p-3" data-testid={testid}>
      <p className={cn("text-xs font-semibold flex items-center gap-1.5", tone)}>
        <Icon className="h-3.5 w-3.5" aria-hidden="true" /> {title}
      </p>
      {text ? (
        <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">{text}</p>
      ) : (
        <ul className="mt-1.5 space-y-1">
          {items.map((s, i) => (
            <li key={i} className="text-xs text-muted-foreground flex items-start gap-1.5">
              <span className="h-1 w-1 rounded-full bg-current opacity-60 mt-1.5 shrink-0" /> {s}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const MeetingPrepCard = ({ prep, onGeneratePlan, asking }) => (
  <div className="rounded-xl border border-athlynx/30 bg-athlynx/[0.04] p-3.5 space-y-2.5" data-testid="meeting-prep-card">
    <div className="flex items-center gap-2">
      <ClipboardList className="h-4 w-4 text-athlynx" aria-hidden="true" />
      <p className="text-sm font-semibold">{tfr("Préparation de réunion")}{prep.athlete_name ? ` — ${prep.athlete_name}` : ""}</p>
    </div>
    <Section Icon={AlertTriangle} title={tfr("Sujets urgents")} tone="text-athlynx" items={prep.urgent_topics} testid="prep-urgent-topics" />
    <Section Icon={FileSignature} title={tfr("Contrats")} tone="text-amber-500" items={prep.contracts} testid="prep-contracts" />
    <Section Icon={HeartPulse} title={tfr("Santé de la relation")} tone="text-emerald-500" text={prep.relationship_health} testid="prep-relationship" />
    <Section Icon={Ban} title={tfr("Blocages carrière")} tone="text-red-500" items={prep.career_blockers} testid="prep-blockers" />
    <Section Icon={MessageCircleQuestion} title={tfr("Questions à poser")} tone="text-blue-500" items={prep.suggested_questions} testid="prep-questions" />
    {onGeneratePlan && (
      <Button size="sm" disabled={asking} onClick={() => onGeneratePlan(prep.athlete_name)}
        className="h-8 gap-1.5 bg-athlynx hover:bg-athlynx/90 text-white" data-testid="meeting-prep-generate-plan">
        <ListChecks className="h-3.5 w-3.5" aria-hidden="true" /> {tfr("Générer un plan d'action")}
      </Button>
    )}
  </div>
);
